export const evu_pv = {
    YearStromGesamtEvuPvClass: {
        url: "StromVerbrauch/gesamtjahrshort",
        defaultSegment: "StromVerbrauch",
        forceRefresh: false,
        receiveType: 'RECEIVE_YearStromGesamtEvuPvClass_evupvReducer'
    }
};